<div class="class-reg-popup">
    <div class="text-center succsess-register-box">
      <img src="assets/img/success-icon.gif" class="card-icon" alt="">
      <h4>You have successfully enrolled for <br><span>'{{data.title}}'</span></h4>
      <p class="mt-3 my-2">Begins on {{data?.schedule?.startDate | date: "dd MMM, YYYY"}}</p>
      <!-- <p class="mt-3 my-2" *ngIf="date.dataType == 'batch">batch Begins on {{data?.startDate | date: "dd MMM, YYYY"}}</p> -->
      
      <button class="btn btn-info mb-0" type="button" (click)="viewCourse()" data-dismiss="modal">VIEW COURSE DETAILS</button>
    </div>
  </div>